
// import { Component, Inject, OnInit } from '@angular/core';
// import { CommonModule } from '@angular/common';
// import { FormsModule } from '@angular/forms';
// import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
// import { SchemaApiService } from '../../../core/services/schema-api.service';

// @Component({
//       selector: 'sw-advanced-lookup-dialog',
//       standalone: true,
//       imports: [CommonModule, FormsModule],
//       template: `
//     <div class="flex flex-col h-[550px] bg-white rounded-xl overflow-hidden shadow-2xl">
//       <div class="px-6 py-4 border-b flex justify-between items-center bg-slate-50">
//         <h3 class="font-bold text-gray-800 uppercase text-xs tracking-wider">
//           Search {{ data.config.label }}
//         </h3>
//         <button (click)="close()" class="text-gray-400 hover:text-red-500 transition-colors">✕</button>
//       </div>

//       <div class="p-4 border-b flex gap-2 bg-white">
//         <div class="relative flex-1">
//           <input 
//             type="text" 
//             class="kt-input w-full pl-10" 
//             [(ngModel)]="query" 
//             (keyup.enter)="doSearch()"
//             placeholder="Type and press Enter to search...">
//           <span class="absolute left-3 top-2.5 text-gray-400">
//             <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//               <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
//             </svg>
//           </span>
//         </div>
//         <button (click)="doSearch()" class="bg-black text-white px-6 py-2 rounded font-bold text-xs uppercase tracking-widest hover:bg-gray-800">
//           Search
//         </button>
//       </div>

//       <div class="flex-1 overflow-auto">
//         <div *ngIf="loading" class="flex flex-col items-center justify-center py-20 text-gray-400">
//            <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mb-2"></div>
//            <span class="text-xs font-bold uppercase tracking-tighter">Searching...</span>
//         </div>

//         <table *ngIf="!loading && items.length > 0" class="w-full text-left text-[11px] border-collapse">
//           <thead class="bg-slate-50 sticky top-0 border-b">
//             <tr>
//               <th *ngFor="let col of data.config.dataSource.columns" class="p-4 font-bold text-gray-500 uppercase">
//                 {{ col.header }}
//               </th>
//               <th class="p-4 font-bold text-gray-500 uppercase text-center">Action</th>
//             </tr>
//           </thead>
//           <tbody class="divide-y divide-gray-100">
//             <tr *ngFor="let row of items" class="hover:bg-blue-50 cursor-pointer transition-colors" (click)="select(row)">
//               <td *ngFor="let col of data.config.dataSource.columns" class="p-4 text-gray-700">
//                 {{ row[col.field] || '---' }}
//               </td>
//               <td class="p-4 text-center">
//                 <button class="text-blue-600 font-bold hover:underline">Select</button>
//               </td>
//             </tr>
//           </tbody>
//         </table>

//         <div *ngIf="!loading && items.length === 0" class="text-center py-20">
//           <p class="text-gray-400 text-xs font-bold uppercase tracking-widest">No records found.</p>
//         </div>
//       </div>
//     </div>
//   `
// })
// export class SwAdvancedLookupDialogComponent implements OnInit {
//       query: string = '';
//       items: any[] = [];
//       loading: boolean = false;

//       constructor(
//             private apiSvc: SchemaApiService,
//             public dialogRef: MatDialogRef<SwAdvancedLookupDialogComponent>,
//             @Inject(MAT_DIALOG_DATA) public data: any
//       ) { }

//       ngOnInit() {
//             this.doSearch();
//       }

//       doSearch() {
//             this.loading = true;
//             this.apiSvc.lookup(this.data.config.dataSource.api, this.query, this.data.filters)
//                   .subscribe({
//                         next: (res) => {
//                               this.items = Array.isArray(res) ? res : [];
//                               console.log("api data", res);

//                               this.loading = false;
//                         },
//                         error: () => this.loading = false
//                   });
//       }

//       select(row: any) {
//             this.dialogRef.close(row);
//       }

//       close() {
//             this.dialogRef.close();
//       }
// }



// import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
// import { CommonModule } from '@angular/common';
// import { FormsModule } from '@angular/forms';
// import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
// import { SchemaApiService } from '../../../core/services/schema-api.service';
// import { Subject, Subscription } from 'rxjs';
// import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

// @Component({
//       selector: 'sw-advanced-lookup-dialog',
//       standalone: true,
//       imports: [CommonModule, FormsModule],
//       template: `
//     <div class="flex flex-col h-[450px] w-full max-w-[600px] bg-white rounded-lg overflow-hidden shadow-xl border border-gray-200">
//       <div class="px-5 py-3 border-b border-gray-100 flex justify-between items-center bg-white">
//         <h3 class="font-semibold text-gray-700 text-sm tracking-tight">
//           Select {{ data.config.label }}
//         </h3>
//         <button (click)="close()" class="text-gray-400 hover:text-gray-600 transition-colors text-lg">×</button>
//       </div>

//       <div class="p-4 bg-white">
//         <div class="relative group">
//           <span class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-primary transition-colors">
//             <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//               <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
//             </svg>
//           </span>
//           <input 
//             type="text" 
//             class="w-full pl-9 pr-4 py-2 bg-gray-50 border border-gray-200 rounded text-sm focus:bg-white focus:border-blue-400 focus:ring-1 focus:ring-blue-100 outline-none transition-all" 
//             [(ngModel)]="query" 
//             (ngModelChange)="onQueryChange($event)"
//             placeholder="Search by name or code...">

//           <div *ngIf="loading" class="absolute right-3 top-1/2 -translate-y-1/2">
//             <div class="animate-spin rounded-full h-3 w-3 border-b-2 border-blue-500"></div>
//           </div>
//         </div>
//       </div>

//       <div class="flex-1 overflow-auto px-4 pb-4">
//         <div *ngIf="!loading && items.length > 0" class="border border-gray-100 rounded overflow-hidden">
//           <table class="w-full text-left text-[12px]">
//             <thead class="bg-gray-50 border-b border-gray-100">
//               <tr>
//                 <th *ngFor="let col of data.config.dataSource.columns" class="px-4 py-2 font-bold text-gray-500 uppercase tracking-wider">
//                   {{ col.header }}
//                 </th>
//                 <th class="px-4 py-2 font-bold text-gray-500 uppercase tracking-wider text-right">Action</th>
//               </tr>
//             </thead>
//             <tbody class="divide-y divide-gray-50">
//               <tr *ngFor="let row of items" 
//                   class="hover:bg-blue-50/50 cursor-pointer transition-colors group" 
//                   (click)="select(row)">
//                 <td *ngFor="let col of data.config.dataSource.columns" class="px-4 py-2.5 text-gray-600">
//                   {{ row[col.field] || '---' }}
//                 </td>
//                 <td class="px-4 py-2.5 text-right">
//                   <span class="text-blue-500 font-medium group-hover:underline text-[11px]">Select</span>
//                 </td>
//               </tr>
//             </tbody>
//           </table>
//         </div>

//         <div *ngIf="!loading && items.length === 0" class="flex flex-col items-center justify-center py-12 text-gray-400">
//           <p class="text-[11px] font-medium uppercase tracking-widest">No results found</p>
//         </div>
//       </div>
//     </div>
//   `
// })
// export class SwAdvancedLookupDialogComponent implements OnInit, OnDestroy {
//       query: string = '';
//       items: any[] = [];
//       loading: boolean = false;

//       private searchSubject = new Subject<string>();
//       private searchSubscription?: Subscription;

//       constructor(
//             private apiSvc: SchemaApiService,
//             public dialogRef: MatDialogRef<SwAdvancedLookupDialogComponent>,
//             @Inject(MAT_DIALOG_DATA) public data: any
//       ) { }

//       ngOnInit() {
//             // 1. Initialize the debounce search logic
//             this.searchSubscription = this.searchSubject.pipe(
//                   debounceTime(400),        // Wait 400ms after user stops typing
//                   distinctUntilChanged()    // Only search if the text actually changed
//             ).subscribe(searchText => {
//                   this.doSearch(searchText);
//             });

//             // Initial load
//             this.doSearch('');
//       }

//       onQueryChange(value: string) {
//             this.searchSubject.next(value);
//       }

//       doSearch(searchText: string) {
//             this.loading = true;
//             this.apiSvc.lookup(this.data.config.dataSource.api, searchText, this.data.filters)
//                   .subscribe({
//                         next: (res) => {
//                               this.items = Array.isArray(res) ? res : [];
//                               this.loading = false;
//                         },
//                         error: () => this.loading = false
//                   });
//       }

//       select(row: any) {
//             this.dialogRef.close(row);
//       }

//       close() {
//             this.dialogRef.close();
//       }

//       ngOnDestroy() {
//             // Clean up to prevent memory leaks
//             this.searchSubscription?.unsubscribe();
//       }
// }

// import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
// import { CommonModule } from '@angular/common';
// import { FormsModule } from '@angular/forms';
// import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
// import { SchemaApiService } from '../../../core/services/schema-api.service';
// import { Subject, Subscription } from 'rxjs';
// import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

// @Component({
//       selector: 'sw-advanced-lookup-dialog',
//       standalone: true,
//       imports: [CommonModule, FormsModule],
//       template: `
//     <div class="flex flex-col h-auto max-h-[70vh] w-[600px] max-w-full bg-white overflow-hidden shadow-lg rounded-md font-sans border border-slate-200">

//       <div class="px-4 py-2 flex justify-between items-center border-b border-slate-200 bg-slate-50">
//         <h3 class="font-bold text-slate-700 text-[11px] uppercase tracking-wider">
//           {{ data.config.label || 'Select Record' }}
//         </h3>
//         <button (click)="close()" class="text-slate-400 hover:text-rose-600 transition-colors p-0.5 rounded">
//           <svg class="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//             <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
//           </svg>
//         </button>
//       </div>

//       <div class="p-3 bg-white border-b border-slate-100">
//         <div class="relative group">
//           <span class="absolute left-2.5 top-1/2 -translate-y-1/2 text-slate-400">
//             <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//               <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
//             </svg>
//           </span>
//           <input 
//             type="text" 
//             autofocus
//             class="w-full pl-8 pr-8 py-1.5 bg-slate-50 border border-slate-200 rounded text-[11px] text-slate-800 focus:bg-white focus:border-[#009EF7] focus:ring-1 focus:ring-[#009EF7] outline-none transition-all placeholder:text-slate-400" 
//             [(ngModel)]="ngModelQuery" 
//             (ngModelChange)="onQueryChange($event)"
//             placeholder="Search by name or code...">

//           <div *ngIf="loading" class="absolute right-2.5 top-1/2 -translate-y-1/2">
//             <div class="animate-spin rounded-full h-3 w-3 border-b-2 border-[#009EF7]"></div>
//           </div>
//         </div>
//       </div>

//       <div class="flex-1 overflow-y-auto h-auto min-h-[250px] bg-white">
//         <table *ngIf="!loading && items.length > 0" class="w-full text-left border-collapse">
//           <thead class="bg-white border-b border-slate-200 sticky top-0 z-10">
//             <tr>
//               <th *ngFor="let col of data.config.dataSource.columns" class="px-4 py-2 font-semibold text-slate-400 uppercase text-[9px] tracking-widest">
//                 {{ col.header }}
//               </th>
//               <!-- <th class="px-4 py-2 font-semibold text-slate-400 uppercase text-[9px] tracking-widest text-right w-20">Action</th> -->
//             </tr>
//           </thead>
//           <tbody class="divide-y divide-slate-100">
//             <tr *ngFor="let row of items" 
//                 class="hover:bg-slate-50 cursor-pointer transition-colors group" 
//                 (click)="select(row)">
//               <td *ngFor="let col of data.config.dataSource.columns" class="px-4 py-1.5 text-slate-700 text-[11px] font-medium align-middle">
//                 {{ row[col.field] || '---' }}
//               </td>
//               <td class="px-4 py-1.5 text-right align-middle">
//                 <!-- <button class="text-[#009EF7] font-semibold hover:text-white text-[9px] uppercase bg-transparent hover:bg-[#009EF7] px-2.5 py-1 rounded transition-colors border border-slate-200 hover:border-[#009EF7]">
//                   Select
//                 </button> -->
//               </td>
//             </tr>
//           </tbody>
//         </table>

//         <div *ngIf="!loading && items.length === 0" class="flex flex-col items-center justify-center py-12">
//           <svg class="w-8 h-8 text-slate-200 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//             <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"></path>
//           </svg>
//           <p class="text-[10px] font-bold text-slate-400 uppercase tracking-widest">No Data Found</p>
//         </div>
//       </div>
//     </div>
//   `
// })
// export class SwAdvancedLookupDialogComponent implements OnInit, OnDestroy {
//       ngModelQuery: string = '';
//       items: any[] = [];
//       loading: boolean = false;

//       private searchSubject = new Subject<string>();
//       private searchSubscription?: Subscription;

//       constructor(
//             private apiSvc: SchemaApiService,
//             public dialogRef: MatDialogRef<SwAdvancedLookupDialogComponent>,
//             @Inject(MAT_DIALOG_DATA) public data: any
//       ) { }

//       ngOnInit() {
//             this.searchSubscription = this.searchSubject.pipe(
//                   debounceTime(350),
//                   distinctUntilChanged()
//             ).subscribe(text => this.doSearch(text));

//             this.doSearch('');
//       }

//       onQueryChange(value: string) {
//             this.searchSubject.next(value);
//       }

//       doSearch(searchText: string) {
//             this.loading = true;
//             this.apiSvc.lookup(this.data.config.dataSource.api, searchText, this.data.filters)
//                   .subscribe({
//                         next: (res) => {
//                               this.items = Array.isArray(res) ? res : [];
//                               this.loading = false;
//                         },
//                         error: () => this.loading = false
//                   });
//       }

//       select(row: any) { this.dialogRef.close(row); }
//       close() { this.dialogRef.close(); }
//       ngOnDestroy() { this.searchSubscription?.unsubscribe(); }
// }


import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SchemaApiService } from '../../../core/services/schema-api.service';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'sw-advanced-lookup-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule],
  template: `
    <div class="kt-modal-content max-w-[600px] w-full bg-white shadow-sm border border-slate-200 overflow-hidden font-sans">
      
      <div class="kt-modal-header py-3 px-5 flex items-center justify-between border-b border-slate-100 bg-white">
        <h3 class="kt-modal-title text-[13px] font-bold text-slate-800 uppercase tracking-tight">
          {{ data.config.label || 'Select Record' }}
        </h3>
        <button
          type="button"
          class="kt-modal-close text-slate-400 hover:text-primary transition-colors"
          (click)="close()"
          aria-label="Close modal"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M18 6 6 18"></path>
            <path d="m6 6 12 12"></path>
          </svg>
        </button>
      </div>

      <div class="kt-modal-body p-4 overflow-hidden flex flex-col gap-4">
        
        <div class="relative">
          <input
            type="text"
            autofocus
            data-kt-modal-input-focus="true"
            class="kt-input w-full px-4 py-2 text-[12px] bg-slate-50 border border-slate-200 rounded-md focus:bg-white focus:border-primary focus:ring-1 focus:ring-primary/20 outline-none transition-all placeholder:text-slate-400"
            [(ngModel)]="ngModelQuery" 
            (ngModelChange)="onQueryChange($event)"
            placeholder="Search by name or code..."
          />
          <div *ngIf="loading" class="absolute right-3 top-1/2 -translate-y-1/2">
            <div class="animate-spin rounded-full h-3.5 w-3.5 border-b-2 border-primary"></div>
          </div>
        </div>

        <div class="max-h-[350px] overflow-y-auto border border-slate-100 rounded-md">
          <!-- <table *ngIf="!loading && items.length > 0" class="w-full text-left border-collapse">
            <thead class="bg-slate-50 border-b border-slate-100 sticky top-0 z-10">
              <tr>
                <th *ngFor="let col of data.config.filterColumns" class="px-4 py-2.5 font-bold text-slate-500 uppercase text-[10px] tracking-wider">
                  {{ col.header }}
                </th>
               
              </tr>
            </thead>
            <tbody class="divide-y divide-slate-50">
              <tr *ngFor="let row of items" 
                  class="hover:bg-blue-50/30 cursor-pointer transition-colors group" 
                  (click)="select(row)">
                <td *ngFor="let col of data.config.filterColumns" class="px-4 py-2.5 text-slate-700 text-[11px] font-medium">
                  {{ row[col.field] || '---' }}
                </td>
                <td class="px-4 py-2.5 text-right">
                 
                </td>
              </tr>
</tbody>
          </table> -->
          <table *ngIf="!loading && items.length > 0" class="w-full text-left border-collapse">
  <thead class="bg-slate-50 border-b border-slate-100 sticky top-0 z-10">
    <tr>
      <th *ngFor="let col of data.config.filterColumns"
          class="px-4 py-2.5 font-bold text-slate-500 uppercase text-[10px] tracking-wider">
        {{ col.header }}
      </th>
    </tr>
  </thead>
  <tbody class="divide-y divide-slate-50">
    <tr *ngFor="let row of items"
        class="hover:bg-blue-50/30 cursor-pointer transition-colors group"
        (click)="select(row)">

      <td *ngFor="let col of data.config.filterColumns"
          class="px-4 py-2.5 text-slate-700 text-[11px] font-medium">

        <span [class.text-blue-600]="col.field === 'code'" [class.font-bold]="col.field === 'code'">
          {{ row[col.field] || '---' }}
        </span>

      </td>
    </tr>
  </tbody>
</table>

          <div *ngIf="!loading && items.length === 0" class="flex flex-col items-center justify-center py-10 bg-slate-50/50">
            <p class="text-[10px] font-bold text-slate-400 uppercase tracking-[0.2em]">No records found</p>
          </div>
        </div>

      </div>
    </div>
  `
})
export class SwAdvancedLookupDialogComponent implements OnInit, OnDestroy {
  ngModelQuery: string = '';
  items: any[] = [];
  loading: boolean = false;

  private searchSubject = new Subject<string>();
  private searchSubscription?: Subscription;

  constructor(
    private apiSvc: SchemaApiService,
    public dialogRef: MatDialogRef<SwAdvancedLookupDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.searchSubscription = this.searchSubject.pipe(
      debounceTime(350),
      distinctUntilChanged()
    ).subscribe(text => this.doSearch(text));

    this.doSearch(''); // Initial load
  }

  onQueryChange(value: string) {
    this.searchSubject.next(value);
  }

  doSearch(searchText: string) {
    this.loading = true;
    this.apiSvc.lookupRuntime(this.data.config.dataSource.api, searchText, this.data.filters)
      .subscribe({
        next: (res) => {
          this.items = Array.isArray(res) ? res : [];
          this.loading = false;
        },
        error: () => this.loading = false
      });
  }

  select(row: any) { this.dialogRef.close(row); }
  close() { this.dialogRef.close(); }
  ngOnDestroy() { this.searchSubscription?.unsubscribe(); }
}